/* eslint-disable import/no-cycle */
import _ from 'lodash';
import { handleActions } from 'redux-actions';
import { 	
	// SYNCING
	addIsSyncing, 
	removeIsSyncing, 
	clearIsSyncing,
	
	addIsUnsyncing, 
	removeIsUnsyncing, 
	clearIsUnsyncing,
	
	// DELETING
	addIsDeleting, 
	removeIsDeleting, 
	clearIsDeleting,

	addIsDeleted,
	removeIsDeleted,
	clearIsDeleted,

	addIsQueuedForDelete,
	removeIsQueuedForDelete,
	clearIsQueuedForDelete,
		
	// SELECTED SURVEYS
	addIsSelected, 
	removeIsSelected, 
	clearIsSelected,

	// AUTO FIX PM/CTS
	setAutoFixStore,
	addAutoFixPmCt,
	removeAutoFixPmCt, 
	clearAutoFixPmCt,

	// CACHED JOBS - Component JobList Local State Cache - CISV JobList component manages state locally, this allows us to cache that local state in redux and make it available to our selectors.
	setJobListTab,
	setFJobs,
	setSJobs,
	setAutoFixIsFixing,
	setAutoFixIsStopping,
	
	// ERROR MESSAGES
	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,
} from './actions';
import { initialState } from './initialState';
import {
	selectSurveyGuidMaps,
	selectMapIsSyncing,
	selectMapIsUnsyncing,
	selectMapIsDeleting,
	selectMapErrorMessages,
	selectMapIsSelected,
	selectMapIsQueuedForDelete,
	selectMapIsDeleted,
} from './selectors';
import UTIL_AUTO_FIX from './util.autoFixPmCt';


// ************
// PARTS
// ************

const reducerParts = {
	// eslint-disable-next-line no-unused-vars
	[clear]: () => _.cloneDeep(initialState),



	// ************
	// IS SYNCING
	// ************

	[addIsSyncing]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapIsSyncing(state);
		const _mapAdd = timeuuids.reduce((acc, id) => {
			acc[id] = true;
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isSyncing: {
					..._map,
					..._mapAdd,
				}
			}

		};
	},

	[removeIsSyncing]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapIsSyncing(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isSyncing: _mapClone
			}
		};
	},

	[clearIsSyncing]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isSyncing: {}
			}
		};
	},



	// ************
	// IS UNSYNCING
	// ************

	[addIsUnsyncing]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapIsUnsyncing(state);
		const _mapAdd = timeuuids.reduce((acc, id) => {
			acc[id] = true;
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isUnsyncing: {
					..._map,
					..._mapAdd,
				}
			}

		};
	},

	[removeIsUnsyncing]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapIsUnsyncing(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isUnsyncing: _mapClone
			}
		};
	},

	[clearIsUnsyncing]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isUnsyncing: {}
			}
		};
	},



	// ************
	// IS DELETING
	// ************

	[addIsDeleting]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapIsDeleting(state);
		const _mapAdd = timeuuids.reduce((acc, id) => {
			acc[id] = true;
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isDeleting: {
					..._map,
					..._mapAdd,
				}
			}

		};
	},

	[removeIsDeleting]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapIsDeleting(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isDeleting: _mapClone
			}
		};
	},

	[clearIsDeleting]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isDeleting: {}
			}
		};
	},



	// ************
	// IS DELETED
	// ************

	[addIsDeleted]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapIsDeleted(state);
		const _mapAdd = timeuuids.reduce((acc, id) => {
			acc[id] = true;
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isDeleted: {
					..._map,
					..._mapAdd,
				}
			}

		};
	},

	[removeIsDeleted]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapIsDeleted(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isDeleted: _mapClone
			}
		};
	},

	[clearIsDeleted]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isDeleted: {}
			}
		};
	},



	// ************
	// IS QUEUED FOR DELETE
	// ************

	[addIsQueuedForDelete]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapIsQueuedForDelete(state);
		const _mapAdd = timeuuids.reduce((acc, id) => {
			acc[id] = true;
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isQueuedForDelete: {
					..._map,
					..._mapAdd,
				}
			}

		};
	},

	[removeIsQueuedForDelete]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapIsQueuedForDelete(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isQueuedForDelete: _mapClone
			}
		};
	},

	[clearIsQueuedForDelete]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isQueuedForDelete: {}
			}
		};
	},


	// ************
	// IS SELECTED
	// ************

	[addIsSelected]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapIsSelected(state);
		const _mapAdd = timeuuids.reduce((acc, id) => {
			acc[id] = true;
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isSelected: {
					..._map,
					..._mapAdd,
				}
			}

		};
	},

	[removeIsSelected]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapIsSelected(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isSelected: _mapClone
			}
		};
	},

	[clearIsSelected]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				isSelected: {}
			}
		};
	},



	// ************
	// AUTO FIX PM CT
	// ************

	[setAutoFixStore]: (state, { payload: { autoFixStore } }) => {
		return {
			...state,
			autoFixStore
		}
	},

	[addAutoFixPmCt]: (state, { payload: { customer, jobNumber, lineName, surveys, ct, pm } }) => {
		return {
			...state,
			autoFixStore: UTIL_AUTO_FIX.addAutoFixPmCt({ autoFixStore: state.autoFixStore, customer, jobNumber, lineName, surveys, ct, pm })
		}
	},

	[removeAutoFixPmCt]: (state, { payload: { customer, jobNumber, lineName, surveys, ct, pm } }) => {
		return {
			...state,
			autoFixStore: UTIL_AUTO_FIX.removeAutoFixPmCt({ autoFixStore: state.autoFixStore, customer, jobNumber, lineName, surveys, ct, pm })
		}
	},

	[clearAutoFixPmCt]: (state) => {
		return {
			...state,
			autoFixStore: UTIL_AUTO_FIX.clearAutoFixPmCt()
		}
	},

	[setAutoFixIsFixing]: (state, { payload: { isFixing } }) => { 
		return {
			...state,
			autoFixStore: {
				...(state.autoFixStore || {}),
				isFixing
			}
		}
	},

	[setAutoFixIsStopping]: (state, { payload: { isStopping } }) => { 
		return {
			...state,
			autoFixStore: {
				...(state.autoFixStore || {}),
				isStopping
			}
		}
	},


	// ************ 
	// CACHED JOBS - Component JobList Local State Cache - CISV JobList component manages state locally, this allows us to cache that local state in redux and make it available to our selectors.
	// ************

	[setJobListTab]: (state, { payload: { tab } }) => { // (filter gui tab, initial gui tab)
		return {
			...state,
			jobListCache: {
				...(state.jobListCache || {}),
				jobListTab: tab
			}			
		}
	},

	[setFJobs]: (state, { payload: { fjobs } }) => { // (filter gui tab, initial gui tab)
		return {
			...state,
			jobListCache: {
				...(state.jobListCache || {}),
				fjobs
			}			
		}
	},

	[setSJobs]: (state, { payload: { sjobs } }) => { // (search gui tab, second gui tab)
		return {
			...state,
			jobListCache: {
				...(state.jobListCache || {}),
				sjobs
			}
		}
	},





	// ************
	// ERROR MESSAGES
	// ************

	[addErrorMessages]: (state, { payload: { timeuuids, messages } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _map = selectMapErrorMessages(state);
		const _mapAdd = timeuuids.reduce((acc, id, idx) => {
			acc[id] = messages[idx];
			return acc;
		}, {});

		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				errorMessages: {
					..._map,
					..._mapAdd,
				}
			}
		};
	},

	[removeErrorMessages]: (state, { payload: { timeuuids } }) => {
		if (!timeuuids || !timeuuids.length) {
			return state;
		}
		const _maps = selectSurveyGuidMaps(state);
		const _mapClone = { ...selectMapErrorMessages(state) };
		timeuuids.forEach(id => {
			delete _mapClone[id];
		})
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				errorMessages: _mapClone
			}
		};
	},

	[clearErrorMessages]: (state) => {
		const _maps = selectSurveyGuidMaps(state);
		return {
			...state,
			surveyGuidMaps: {
				..._maps,
				errorMessages: {}
			}
		};
	},
};

export default handleActions(reducerParts, initialState);
